module.exports = __webpack_public_path__ + "img/icon.214dc511.png";